exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-user .user-selected-option{min-width:0}.fts-user .user-selected-option .profile-name>div{white-space:inherit;overflow:inherit;text-overflow:inherit}.fts-user__profile-name{display:flex;align-items:center;margin-left:.275rem}.fts-user__profile-name .profile-username{margin-left:.375rem;color:var(--fts-default)}", ""]);

// exports
